<template>
  <button
    :disabled="disabled"
    class="mci-btn"
    :class="[
      color,
      type,
      size,
      {
        transparent: transparent,
        outline: outline,
        rounded: rounded,
        icon: icon
      }
    ]"
    @click="onClick"
    @blur="onBlur"
  >
    <!-- <slot name="preprend" /> -->
    <span v-if="prepareIcon" class="prepare" :class="prepareIcon" />
    <slot />
    <span v-if="appendIcon" class="append" :class="appendIcon" />
    <!-- <slot name="append" /> -->
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary',
      validator: val => {
        return ['primary', 'secondary', 'warning', 'danger', 'text']
      }
    },
    type: {
      type: String,
      default: '',
      validator: val => {
        return ['border', 'text']
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: val => {
        return ['small', 'medium', 'large']
      }
    },
    transparent: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    icon: {
      type: Boolean,
      default: true
    },
    prepareIcon: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
    onBlur() {
      this.$emit('blur')
    }
  }
}
</script>

<style></style>
